import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosResponse} from 'axios'
import {PatientExtended} from '@/features/patients/types.ts'
import {
    HttpChangeTreatmentRequestsOptions,
    httpChangeTreatmentRequestsStatus
} from '@/features/treatment-requests/services/treatment-requests.http.ts'
import {QUERY_KEYS} from '@/queryClient.ts'

export const useChangeStatus = (
    options?: Omit<
        UseMutationOptions<AxiosResponse<PatientExtended>, unknown, HttpChangeTreatmentRequestsOptions>,
        'mutationFn'
    >
) => {
    const queryClient = useQueryClient()

    return useMutation({
        ...options,
        mutationFn: httpChangeTreatmentRequestsStatus,
        onSuccess: (data, variables, context) => {
            void queryClient.cancelQueries({queryKey: [QUERY_KEYS.TREATMENT_REQUESTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.TREATMENT_REQUESTS]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
